import {
  Box,
  Paper,
  Slider,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { MIN_BLUR, MAX_BLUR } from "../constants";
import { BlurMode } from "../types";
import { useTranslation } from "react-i18next";

interface BlurControlsProps {
  blurLevel: number;
  onBlurLevelChange: (value: number) => void;
  blurMode: BlurMode;
  onBlurModeChange: (mode: BlurMode) => void;
  popupAbove: boolean;
}

export default function BlurControls({
  blurLevel,
  onBlurLevelChange,
  blurMode,
  onBlurModeChange,
  popupAbove,
}: BlurControlsProps) {
  const { t } = useTranslation(["bugherd"]);

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        ...(popupAbove
          ? { bottom: "100%", mb: 1 }
          : { top: "100%", mt: 1 }),
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        p: 1.5,
        borderRadius: "12px",
        backgroundColor: "#fff",
        zIndex: 10,
        minWidth: 180,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Mode toggle */}
      <ToggleButtonGroup
        value={blurMode}
        exclusive
        onChange={(_, val) => val && onBlurModeChange(val as BlurMode)}
        size="small"
        sx={{ width: "100%" }}
      >
        <ToggleButton
          value="normal"
          sx={{ flex: 1, textTransform: "none", fontSize: 12, py: 0.25 }}
        >
          {t("blurNormal")}
        </ToggleButton>
        <ToggleButton
          value="tiles"
          sx={{ flex: 1, textTransform: "none", fontSize: 12, py: 0.25 }}
        >
          {t("blurTiles")}
        </ToggleButton>
      </ToggleButtonGroup>

      {/* Strength slider */}
      <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: "text.secondary", whiteSpace: "nowrap", fontSize: 11 }}
        >
          {t("blurStrength")}
        </Typography>
        <Slider
          value={blurLevel}
          onChange={(_, value) => onBlurLevelChange(value as number)}
          min={MIN_BLUR}
          max={MAX_BLUR}
          size="small"
          sx={{ color: "#7C4DFF" }}
        />
        <Typography variant="caption" sx={{ color: "text.secondary", minWidth: 20 }}>
          {blurLevel}
        </Typography>
      </Box>
    </Paper>
  );
}
